import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const DelayedNavigate = ({ to, delay = 10000, replace = true, state }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setReady(true), Math.max(0, Number(delay)));
    return () => clearTimeout(id); 
  }, [delay]);

  if (!ready) return null;
  return <Navigate to={to} replace={replace} state={state} />;
};

export default DelayedNavigate;
